import { render, staticRenderFns } from "./map.vue?vue&type=template&id=2c5840b6"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports